import { render, staticRenderFns } from "./P_customTable.vue?vue&type=template&id=2ed1d660&scoped=true"
import script from "./P_customTable.vue?vue&type=script&lang=js"
export * from "./P_customTable.vue?vue&type=script&lang=js"
import style0 from "./P_customTable.vue?vue&type=style&index=0&id=2ed1d660&prod&lang=less&scoped=true"
import style1 from "./P_customTable.vue?vue&type=style&index=1&id=2ed1d660&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1d660",
  null
  
)

export default component.exports